import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const Org = lazy(() => import("../Components/ProfilesType/OrgAdmin/Org/Org"));
const OrgAdminHome = lazy(() => import("../Components/ProfilesType/OrgAdmin/OrgAdminHome/OrgAdminHome"));
const OrgAdminCalendar = lazy(() => import("../Components/ProfilesType/OrgAdmin/Calendar/OrgAdminCalendar"));
const InterviewPanel = lazy(() => import("../Components/ProfilesType/OrgAdmin/InterviewPanel/InterviewPanel"));
const UsageLimit = lazy(() => import("../Components/ProfilesType/OrgAdmin/Settings/UsageLimits/UsageLimit"));
const Limit = lazy(() => import("../Components/ProfilesType/OrgAdmin/Settings/UsageLimits/Limit"));
const Billing = lazy(() => import("../Components/ProfilesType/OrgAdmin/Settings/UsageLimits/Billing"));
const Plan = lazy(() => import("../Components/ProfilesType/OrgAdmin/Settings/UsageLimits/Plan"));
const Templates = lazy(() => import("../Components/ProfilesType/OrgAdmin/Templates/Templates"));
const RaiseConcern = lazy(() => import("../Components/ProfilesType/OrgAdmin/Help/RaiseConcern"));

export const orgAdminRoutes = [
    {
        index: true,    
        element: <Suspense fallback={<GlobalLoading />}><OrgAdminHome /></Suspense>
    },
    {
        path : "org",
        element: <Suspense fallback={<GlobalLoading />}><Org /></Suspense>
    },
    {
        path: "calendar",
        element: <Suspense fallback={<GlobalLoading />}><OrgAdminCalendar /></Suspense>,
    },
    {
        path: "interview-panel",
        element: <Suspense fallback={<GlobalLoading />}><InterviewPanel /></Suspense>,
    },
    {
    path: "templates",
    element: <Suspense fallback={<GlobalLoading />}><Templates /></Suspense>,
    },
    {
        path: "usage-limits",
        element: <Suspense fallback={<GlobalLoading />}><UsageLimit /></Suspense>,
        children: [
            {
                index: true,
                element: <Suspense fallback={<GlobalLoading />}><Limit /></Suspense>,
            },
            {
                path: "limit",
                element: <Suspense fallback={<GlobalLoading />}><Limit /></Suspense>,
            },
            {
                path: "billing",
                element: <Suspense fallback={<GlobalLoading />}><Billing /></Suspense>,
            },
            {
                path: "plan",
                element: <Suspense fallback={<GlobalLoading />}><Plan /></Suspense>,
            },
        ],
    },
    {
        path: "raise-concern",
        element: <Suspense fallback={<GlobalLoading />}><RaiseConcern /></Suspense>,
        children: [
            {
                index: true,
                element: <Suspense fallback={<GlobalLoading />}><RaiseConcern /></Suspense>,
            }
        ],
    },
]
